<template>
	<el-row class="homebox">
		<!-- 小屏导航 -->
		<el-row class="navbox hidden-md-and-up hidden-sm-only">
			<el-row class="nav">
				<!-- logo -->
				<el-col :xs="8" class="imgbox disleft">
					<img src="@/assets/image/nav/logo.png">
				</el-col>
				<!-- icon -->
				<el-col :xs="16" class=" xssmbigbox disright">
					<span class="el-icon-s-unfold homexssmicon" @click="navlisAllshow=!navlisAllshow"></span>
				</el-col>
			</el-row>
			<transition name="el-fade-in">
				<el-row :xs="24" class="navlisAll" v-show="navlisAllshow">
					<!-- 	<el-col :xs="24" class="navlist" v-for="(item,i) in navList" :key="i"
						@click.native="navlisAllshowchange">
						<router-link :to="item.path" tag="span">{{item.name}}</router-link>
					</el-col> -->
					<el-menu default-active="2" class="el-menu-vertical-demo" background-color="#545c64"
						text-color="#fff" active-text-color="#ffd04b" :router="true">
						<el-menu-item index="/homemain" @click.native="navlisAllshowchange">
							<i class="el-icon-s-home"></i>
							<span slot="title">HOME</span>
						</el-menu-item>
						<el-menu-item index="/aboutus" @click.native="navlisAllshowchange">
							<i class="el-icon-user"></i>
							<span slot="title">ABOUT US</span>
						</el-menu-item>
						<el-submenu index="/product">
							<template slot="title">
								<i class="el-icon-s-help"></i>
								<span>PRODUCT</span>
							</template>
							<el-menu-item index="/productAntiSilpStrip" @click.native="navlisAllshowchange">Anti-silp
								Strip</el-menu-item>
							<el-menu-item index="/productTactileIndicator" @click.native="navlisAllshowchange">Tactile
								Indicator</el-menu-item>
							<el-menu-item index="/productStairNosing" @click.native="navlisAllshowchange">Stair Nosing
							</el-menu-item>
							<el-menu-item index="/productTactilePaving" @click.native="navlisAllshowchange">Tactile
								Paving</el-menu-item>
							<el-menu-item index="/productFRPProducts" @click.native="navlisAllshowchange">FRP Products
							</el-menu-item>
							<el-menu-item index="/productAccessories" @click.native="navlisAllshowchange">Accessories
							</el-menu-item>
						</el-submenu>
						<el-menu-item index="/news" @click.native="navlisAllshowchange">
							<i class="el-icon-news"></i>
							<span slot="title">NEWS &nbsp;</span>
						</el-menu-item>
						<el-menu-item index="/contactus" @click.native="navlisAllshowchange">
							<i class="el-icon-map-location"></i>
							<span slot="title">CONTACT US</span>
						</el-menu-item>
					</el-menu>
				</el-row>
			</transition>
		</el-row>
		<!-- 小屏导航 -->
		<!-- 大屏导航 -->
		<el-row class="hidden-xs-only bignavbox">
			<div class="nav disleft">
				<img src="@/assets/image/nav/logo.png">
			</div>
			<div class="navright discen">
				<el-menu default-active="0" class="el-menu-demo" mode="horizontal" :router="true">
					<el-menu-item index="/homemain">
						<router-link to="" tag="span">HOME</router-link>
					</el-menu-item>
					<el-menu-item index="/aboutus">
						<router-link to="" tag="span">ABOUT US</router-link>
					</el-menu-item>
					<el-submenu index="3">
						<template slot="title">PRODUCT</template>
						<el-menu-item index="/productAntiSilpStrip">Anti-silp Strip</el-menu-item>
						<el-menu-item index="/productTactileIndicator">Tactile Indicator</el-menu-item>
						<el-menu-item index="/productStairNosing">Stair Nosing</el-menu-item>
						<el-menu-item index="/productTactilePaving">Tactile Paving</el-menu-item>
						<el-menu-item index="/productFRPProducts">FRP Products</el-menu-item>
						<el-menu-item index="/productAccessories">Accessories</el-menu-item>
					</el-submenu>
					<el-menu-item index="/news">
						<router-link to="" tag="span">NEWS</router-link>
					</el-menu-item>
					<el-menu-item index="/contactus">
						<router-link to="" tag="span">CONTACT US</router-link>
					</el-menu-item>
				</el-menu>
			</div>
		</el-row>


		<!-- 大屏导航 -->

		<!-- 内容区域 -->
		<el-row class="homeboxmain">
			<router-view></router-view>
		</el-row>
	</el-row>
</template>

<script>
	export default {
		data() {
			return {
				// navList: [{
				// 		name: 'HOME',
				// 		path: '/homemain'
				// 	},
				// 	{
				// 		name: 'ABOUT US',
				// 		path: '/aboutus'
				// 	},
				// 	{
				// 		name: 'PRODUCT',
				// 		path: '/product'
				// 	},
				// 	{
				// 		name: 'NEWS',
				// 		path: '/news'
				// 	},
				// 	{
				// 		name: 'CONTACT US',
				// 		path: '/contactus'
				// 	},
				// ],
				navlisAllshow: false, //控制导航显示
			}
		},
		methods: {
			//控制导航显示
			navlisAllshowchange() {
				this.navlisAllshow = false;
			},
		}
	}
</script>

<style lang='less' scoped>
	.homebox {
		margin: 0;
		padding: 0;

		/* 小屏样式 */
		/deep/ .navbox {
			background-color: #fff;
			color: #1a1a1a;
			line-height: 8vh;
			height: 8vh;
			box-sizing: border-box;

			.nav {
				width: 100%;
				height: 100%;
				padding: 0 5vw;
				background-color: #dee1e6;

				.imgbox {
					padding: 0;
					height: 100%;

					img {
						height: 80%;
					}
				}

				.xssmbigbox {
					height: 100%;

					.homexssmicon {
						font-size: 36px;
					}
				}
			}


			.navlisAll {
				position: relative;
				z-index: 999999;
				font-size: 18px;
				font-weight: 700;

				.navlist {
					background-color: #99a9bf;
					border-bottom: 1px solid #807058;
					height: 50px;
					line-height: 50px;

					span {
						display: inline-block;
						text-align: center;
						width: 100%;
						height: 100%;
					}
				}
			}
		}

		/* 大屏样式 */
		.bignavbox {
			background-color: #fff;
			color: #1a1a1a;
			line-height: 60px;
			height: 60px;
			box-sizing: border-box;
			border-bottom: solid 1px #e6e6e6;
			width: 100%;
			box-sizing: border-box;
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin: 0 auto;

			.nav {
				max-width: 50%;
				height: 100%;

				img {
					height: 80%;
				}
			}

			.navright {
				font-size: 18px;
				font-weight: 700;

				.navlisAll {
					.navlist {
						text-align: right;
					}
				}
			}
		}

		/* 大屏样式 */
		/* 内容 */
		.homeboxmain {
			padding: 0;
			margin: 0;
		}
	}

	/deep/.el-menu--horizontal>.el-menu-item span {
		display: inline-block;
		height: 100%;
		width: 100%;
	}
</style>
